import React from 'react'
import { Link } from 'react-router-dom'

import { Button, Page } from '@fielded/shared-ui'
import OfflineBanner from './OfflineBanner'

const Complete = ({
  noteName,
  printPathname,
  isAdjustment,
  isPsmResellerFacility,
  packageNotePathName,
  isOnline
}) => {
  let redirectLink = '/shipments/'
  if (isPsmResellerFacility) {
    redirectLink = `${redirectLink}facility/deliveries`
  }

  const doneButtonProps = {
    component: Link,
    to: redirectLink,
    colorVariant: 'brand',
    fill: 'full'
  }

  return (
    <Page className={isAdjustment ? 'vs-page vs-page--situation-ready vs-page__content' : 'page--confetti'}>
      <Page.Intro
        centered
        title="You're done!"
      />
      {!isOnline && (
        <Page.Panel narrow className='offline-banner-panel'>
          <OfflineBanner />
        </Page.Panel>
      )}
      <Page.Panel
        withBackground
        narrow
        className='completion-card'
      >
        <Page.Panel.Header title='Delivery recorded' />
        <Page.Panel.Section>
          You're all done - the delivery record has been saved.
        </Page.Panel.Section>
        <Page.Panel.Actions className='complete-actions'>
          {
            packageNotePathName &&
            (<Button
              component={Link}
              to={packageNotePathName}
              colorVariant='brand'
              fill='outline'
              alignOpposite
            >
            Package note
            </Button>
            )}

          <Button
            component={Link}
            to={printPathname}
            colorVariant='brand'
            fill='outline'
            alignOpposite
          >
            Print {noteName}
          </Button>

          <Button
            {...doneButtonProps}
          >
            Finish {!isOnline && '& queue'}
          </Button>
        </Page.Panel.Actions>
      </Page.Panel>
    </Page>
  )
}

export default Complete
